import { useMapSlice } from 'app/containers/Map/slice';
import React, { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectMappedDrawnFieldsList } from '../../slice/selectors';
import TempFieldsList from '../TempFieldsList/TempFieldsList';
import useUploadDrawnPolygons from '../../../../../utils/hooks/useUploadDrawnPolygons';
import { FormInstance } from 'antd';

interface IProps {
  formId: string;
  form: FormInstance;
}

const DrawnFieldsList: FC<IProps> = ({ formId, form }) => {
  const dispatch = useDispatch();

  const { actions: mapActions } = useMapSlice();

  const mappedTempFieldList = useSelector(selectMappedDrawnFieldsList);

  const { onSubmit } = useUploadDrawnPolygons();

  const onClick = (id: string) => () => {
    dispatch(mapActions.toggleTempPolygon(id));
  };

  const onFocus = (id: string) => () => {
    dispatch(mapActions.zoomOnDrawnPolygon(id));
  };

  return (
    <TempFieldsList
      form={form}
      formId={formId}
      selectedIds={mappedTempFieldList.map(field => field.id)}
      fieldsArr={mappedTempFieldList}
      onListItemClick={onClick}
      onListItemInputFocus={onFocus}
      onSubmit={onSubmit}
    />
  );
};

export default DrawnFieldsList;
